import { render, staticRenderFns } from "./ColorPallete.vue?vue&type=template&id=28694566&scoped=true&"
import script from "./ColorPallete.vue?vue&type=script&lang=ts&"
export * from "./ColorPallete.vue?vue&type=script&lang=ts&"
import style0 from "./ColorPallete.vue?vue&type=style&index=0&id=28694566&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28694566",
  null
  
)

export default component.exports